import { ALL_CHANNELS_ID } from '../../constants';

export const getChannelCategoryIdsByTabId = (currentCategoryTabId: string): number[] =>
    currentCategoryTabId === ALL_CHANNELS_ID ? [] : [Number(currentCategoryTabId)];
